// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zy98","field":"styles_field__3mrxN","fieldCol":"styles_fieldCol__N4xLk","diffCol":"styles_diffCol__1kM9h","diff":"styles_diff__1R5Wc"};